<div class="dropdown-tree-container">
  <app-base-label
    [required]="checkRequiredField()"
    *ngIf="label"
    [label]="label"
    [labelOneLine]="labelOneLine"
  >
  </app-base-label>

  <p-treeSelect
    (onNodeSelect)="handleOnNodeSelect($event)"
    [(ngModel)]="selectedValue"
    [options]="sortedOptions"
    [placeholder]="placeholder"
  >
  </p-treeSelect>

  <!-- <p-dropdown #dropdown class="dropdown-item" [options]="options" appendTo="body" [placeholder]="placeholder"
    [formControl]="fieldControl" [ngClass]="{ invalid: checkInvalidField() }" optionLabel="label" optionValue="value"
    optionDisabled="disabled" [disabled]="disabled" [autoDisplayFirst]="false" [filter]="searchable" filterBy="label"
    [showClear]="false" (onChange)="onChange()">
    <ng-template pTemplate="selectedItem">
      {{ getLabelByValue(fieldControl.value) | translate }}
    </ng-template>
    <ng-template let-option pTemplate="item">
      <div>{{ option.label | translate }}</div>
    </ng-template>
  </p-dropdown> -->
  <app-base-label
    ngClass="mt-1"
    *ngIf="checkInvalidField()"
    [label]="errorMessage"
    mode="error"
  >
  </app-base-label>
</div>
